// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "9dadc25a" + "." + "64c5296025e15c08" + ".js";
};